import { render, staticRenderFns } from "./ProjectNodesMemberDetails.vue?vue&type=template&id=6f9d0710"
import script from "./ProjectNodesMemberDetails.vue?vue&type=script&lang=js"
export * from "./ProjectNodesMemberDetails.vue?vue&type=script&lang=js"
import style0 from "./ProjectNodesMemberDetails.vue?vue&type=style&index=0&id=6f9d0710&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports